var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fondoGrisOscuro",attrs:{"id":"section7"}},[_c('b-container',{attrs:{"fluid":""}},[_c('b-container',{staticClass:"mt-3 mb-3"},[_c('tyt',{attrs:{"titles":_vm.title,"activo":"false","videos":_vm.videosID}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }